// extracted by mini-css-extract-plugin
export default {"wrapper":"Chats_wrapper__f2v3P","chats_wrapper":"Chats_chats_wrapper__vYqgc","chat_wrapper":"Chats_chat_wrapper__ZclvN","active":"Chats_active__WDpag"};